export const SEARCH_PARAM = 'SEARCH_PARAM';
export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';

export default {
	SEARCH_PARAM,
	DEFAULT_ASSIGN
};
